// Store actions constants
export const ACTION_LOADING = 'ACTION_LOADING';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SET_LANGUAGE = 'SET_LANGUAGE'; 